import { render, staticRenderFns } from "./mem_action.vue?vue&type=template&id=815e6742&scoped=true&"
import script from "./mem_action.vue?vue&type=script&lang=js&"
export * from "./mem_action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e6742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('815e6742')) {
      api.createRecord('815e6742', component.options)
    } else {
      api.reload('815e6742', component.options)
    }
    module.hot.accept("./mem_action.vue?vue&type=template&id=815e6742&scoped=true&", function () {
      api.rerender('815e6742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/mem_action.vue"
export default component.exports